var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flat-icon-button",style:({
        '--icon-size': _vm.iconSize + 'px'
    }),attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[(_vm.text)?_c('span',{staticClass:"button__text"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),(_vm.loading)?[_c('LoadingSpinner',{attrs:{"size":_vm.iconSize}})]:[_vm._t("svgIcon")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }